import type { QualityItemKind } from '../domain-types';

export type WorkflowModule = {
  kind: QualityItemKind;
  name: string;
  detail: string;
  icon: string;
};

export const workflowModules: WorkflowModule[] = [
  {
    kind: 'plan',
    name: 'Planning',
    detail: 'Quality plans, obligations and improvement actions',
    icon: '◫',
  },
  {
    kind: 'schedule',
    name: 'Scheduling',
    detail: 'Monitoring and evaluation calendar',
    icon: '◷',
  },
  {
    kind: 'audit',
    name: 'Internal audits',
    detail: 'Programs, evidence, findings and follow-up',
    icon: '◎',
  },
  {
    kind: 'survey',
    name: 'Stakeholder surveys',
    detail: 'Feedback collection and evaluation',
    icon: '◇',
  },
];

export function WorkflowModulePanel({
  modules,
  onOpen,
}: {
  modules: WorkflowModule[];
  onOpen: (kind: QualityItemKind) => void;
}) {
  return (
    <section className="module-grid">
      {modules.map((module, index) => (
        <article id={module.name.toLowerCase().replaceAll(' ', '-')} key={module.name}>
          <div className="module-top">
            <span>{module.icon}</span>
            <small>0{index + 1}</small>
          </div>
          <h3>{module.name}</h3>
          <p>{module.detail}</p>
          <button type="button" onClick={() => onOpen(module.kind)}>
            Open module →
          </button>
        </article>
      ))}
    </section>
  );
}
